// Auth Actions
import { createAction, props } from '@ngrx/store';
import { User } from './auth.state';

// Login
export const login = createAction(
  '[Auth] Login',
  props<{ email: string; password: string }>()
);
export const loginSuccess = createAction(
  '[Auth] Login Success',
  props<{ user: User; token: string; refreshToken: string }>()
);
export const loginFailure = createAction(
  '[Auth] Login Failure',
  props<{ error: string }>()
);

// SSO Login
export const ssoLogin = createAction(
  '[Auth] SSO Login',
  props<{ token: string; refreshToken: string }>()
);
export const ssoLoginSuccess = createAction(
  '[Auth] SSO Login Success',
  props<{ user: User; token: string; refreshToken: string }>()
);
export const ssoLoginFailure = createAction(
  '[Auth] SSO Login Failure',
  props<{ error: string }>()
);

// Logout
export const logout = createAction('[Auth] Logout');
export const logoutSuccess = createAction('[Auth] Logout Success');

// Restore from storage
export const restoreAuth = createAction('[Auth] Restore Auth');
export const restoreAuthSuccess = createAction(
  '[Auth] Restore Auth Success',
  props<{ user: User; token: string; refreshToken: string }>()
);
export const restoreAuthFailure = createAction('[Auth] Restore Auth Failure');

// Update profile
export const updateProfile = createAction(
  '[Auth] Update Profile',
  props<{ user: Partial<User> }>()
);
